import { useReducer } from 'react';
import { customTableReducer } from '../../../../../hooks/tableHook';
import { DC } from './variables';

export const useWhiteLabelReducer = ({
  initialSearchParams,
  resetSearchParams,
}) => {
  const [searchParams, dispatch] = useReducer(
    customTableReducer({ resetSearchParams, customReducer }),
    initialSearchParams
  );
  return [searchParams, dispatch];
};

const customReducer = (state, { type, payload }) => {
  switch (type) {
    case DC.ENTER_SEARCH:
      return {
        ...state,
        [DC.SEARCH]: state.searchValue,
        [DC.FILTERS_SET]: true,
      };
    default:
      return state;
  }
};
